import React from 'react';
import PropTypes from 'prop-types';
import { Query } from '@apollo/client/react/components';
import { gql } from '@apollo/client';
import { get as lodashGet, set as lodashSet } from 'lodash';

import { GQL_TAG_FRAGMENT } from './fragments';

export const GQL_GET_TAGS = gql`
  query GetTags($nodeId: ID!) {
    node(id: $nodeId) {
      __typename
      id
      ... on RecordableInterface {
        tags(last: 100) {
          __typename
          edges {
            node {
              ...TagFragment
            }
          }
        }
      }
    }
  }

  ${GQL_TAG_FRAGMENT}
`;

const tagsFromData = (data) => lodashGet(data, 'node.tags.edges', []);

const updateTagsCacheSetEdges = ({ cache, newEdges, nodeId }) => {
  try {
    const cachedData = cache.readQuery({
      query: GQL_GET_TAGS,
      variables: { nodeId },
    });

    const newData = lodashSet(cachedData, 'node.tags.edges', newEdges);
    cache.writeQuery({
      query: GQL_GET_TAGS,
      variables: { nodeId },
      data: newData,
    });
  } catch (e) {
    // no cache to update
  }
};

const TagsDataProvider = ({ children, variables }) => (
  <Query
    query={GQL_GET_TAGS}
    variables={variables}
    fetchPolicy="cache-and-network"
  >
    {({ loading, error, data, refetch }) => {
      const tags = tagsFromData(data).map((edge) => edge.node);

      return children({
        fetchingResults: loading,
        fetchError: !!error,
        tags,
        refetch,
      });
    }}
  </Query>
);

TagsDataProvider.propTypes = {
  children: PropTypes.func,
  variables: PropTypes.shape({
    nodeId: PropTypes.string,
  }),
};

export { updateTagsCacheSetEdges, TagsDataProvider };
